module.exports = __webpack_public_path__ + "img/TrustBy_Ampath.4d4458f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/professional/TrustBy_Ampath.png
// module id = 601
// module chunks = 5